// Layout modules are consumed through the `./layout/*` subpath exports, matching
// tw-shadcn. This barrel exports the shared presentation primitives.
export { AccessibleHiddenText } from './accessible-hidden-text';
export { AdvertisingDisclosure } from './AdvertisingDisclosure/AdvertisingDisclosure';
export type { AdvertisingDisclosureProps } from './AdvertisingDisclosure/AdvertisingDisclosure';
export { CardCtaLink } from './AdvisorSearch/CardCtaLink';
export type { CardCtaLinkProps } from './AdvisorSearch/CardCtaLink';
export { DueDiligenceChecklist } from './AdvisorSearch/DueDiligenceChecklist';
export type { DueDiligenceChecklistProps } from './AdvisorSearch/DueDiligenceChecklist';
export { FeeStructureTable } from './AdvisorSearch/FeeStructureTable';
export { GoodToKnowSection } from './AdvisorSearch/GoodToKnowSection';
export { KeyTermsSection } from './AdvisorSearch/KeyTermsSection';
export { LegalDisclosure } from './AdvisorSearch/LegalDisclosure';
export type { LegalDisclosureProps } from './AdvisorSearch/LegalDisclosure';
export { LinkCard } from './AdvisorSearch/LinkCard';
export type { LinkCardProps } from './AdvisorSearch/LinkCard';
export { LinkCardGrid } from './AdvisorSearch/LinkCardGrid';
export { RiaTable } from './AdvisorSearch/RiaTable';
export type { RiaTableProps, RiaTableRow } from './AdvisorSearch/RiaTable';
export { SectionHeader } from './AdvisorSearch/SectionHeader';
export type { SectionHeaderProps } from './AdvisorSearch/SectionHeader';
export { TopAdvisorsByCity } from './AdvisorSearch/TopAdvisorsByCity';
export { TypesOfAdvisors } from './AdvisorSearch/TypesOfAdvisors';
export { UnderHeroLegalDisclosure } from './AdvisorSearch/UnderHeroLegalDisclosure';
export { Badge } from './badge';
export type { BadgeProps } from './badge';
export { BRAND_ICONS, BrandIcon } from './brand-icon';
export type { BrandIconName } from './brand-icon';
export { Breadcrumbs } from './Breadcrumbs/Breadcrumbs';
export type { BreadcrumbsProps } from './Breadcrumbs/Breadcrumbs';
export { CtaButton, TrackedLink } from './Cta';
export type { CtaButtonProps, CtaButtonVariant, TrackedLinkProps } from './Cta';
export { Details } from './details';
export type { DetailsProps } from './details';
export { DisclosureTooltip } from './DisclosureTooltip/DisclosureTooltip';
export type { DisclosureTooltipProps } from './DisclosureTooltip/DisclosureTooltip';
export { INVESTING_COPY } from './EditorialStandards/constants';
export { EditorialStandards } from './EditorialStandards/EditorialStandards';
export type { EditorialStandardsProps } from './EditorialStandards/EditorialStandards';
export { ErrorPopup } from './error-popup';
export { DEFAULT_STATE_OPTION, STATE_OPTIONS } from './GeoTargeting/constants';
export { GeoDropdown } from './GeoTargeting/GeoDropdown';
export { GeoProvider, useGeo } from './GeoTargeting/GeoProvider';
export { NerdWalletBadge } from './nerdwallet-badge';
export { PageHeader } from './PageHeader/PageHeader';
export type { PageHeaderProps } from './PageHeader/PageHeader';
export { ProsAndCons } from './pros-and-cons';
export { RecapListWrapper } from './RecapList/RecapList';
export type { RecapListWrapperProps } from './RecapList/RecapList';
export { RiaDisclaimer } from './RiaDisclaimer/RiaDisclaimer';
export { ShowMore } from './show-more';
export type { ShowMoreProps } from './show-more';
export { BaseLayout } from './StarRating/BaseLayout';
export type { BaseLayoutProps } from './StarRating/BaseLayout';
export { BigNumberLayout } from './StarRating/BigNumberLayout';
export type { BigNumberLayoutProps } from './StarRating/BigNumberLayout';
export { NumericLayout } from './StarRating/NumericLayout';
export type { NumericLayoutProps } from './StarRating/NumericLayout';
export { RatingSummary } from './StarRating/RatingSummary';
export { RatingTooltip } from './StarRating/RatingTooltip';
export { ShortHorizontalLayout } from './StarRating/ShortHorizontalLayout';
export type { ShortHorizontalLayoutProps } from './StarRating/ShortHorizontalLayout';
export { StarRating } from './StarRating/StarRating';
export { StarRatingAboveTooltipBelowLayout } from './StarRating/StarRatingAboveTooltipBelowLayout';
export type { StarRatingAboveTooltipBelowLayoutProps } from './StarRating/StarRatingAboveTooltipBelowLayout';
export { TableOfContents } from './TableOfContents/TableOfContents';
export type { TableOfContentsProps } from './TableOfContents/TableOfContents';
